const drawCard = (ctx, canvas, userData, photoImg) => {
  const photoX = 60;
  const photoY = 160;
  const photoSize = 140;
  const radius = 20;

  // Fond dégradé
  const gradient = ctx.createLinearGradient(0, 0, canvas.width, canvas.height);
  gradient.addColorStop(0, '#3B5BA5');
  gradient.addColorStop(1, '#0a0f2e');
  ctx.fillStyle = gradient;
  ctx.fillRect(0, 0, canvas.width, canvas.height);

  // Ligne header
  ctx.strokeStyle = 'rgba(255, 255, 255, 0.2)';
  ctx.lineWidth = 2;
  ctx.beginPath();
  ctx.moveTo(40, 120);
  ctx.lineTo(816, 120);
  ctx.stroke();

  // Titre
  ctx.fillStyle = '#FFFFFF';
  ctx.font = 'bold 28px Arial';
  ctx.textAlign = 'right';
  ctx.textBaseline = 'middle';
  ctx.fillText('CARTE DE MEMBRE', 816, 75);

  // Zone photo (clip arrondi)
  ctx.save();
  ctx.beginPath();
  ctx.roundRect(photoX, photoY, photoSize, photoSize, radius);
  ctx.clip();

  if (photoImg) {
    ctx.drawImage(photoImg, photoX, photoY, photoSize, photoSize);
  } else {
    const photoGradient = ctx.createLinearGradient(photoX, photoY, photoX + photoSize, photoY + photoSize);
    photoGradient.addColorStop(0, '#FF6B00');
    photoGradient.addColorStop(1, '#ff8c00');
    ctx.fillStyle = photoGradient;
    ctx.fillRect(photoX, photoY, photoSize, photoSize);
    ctx.fillStyle = '#FFFFFF';
    ctx.font = 'bold 56px Arial';
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    const initials = `${userData.prenom?.charAt(0) || ''}${userData.nom?.charAt(0) || ''}`;
    ctx.fillText(initials, photoX + photoSize / 2, photoY + photoSize / 2);
  }
  ctx.restore();

  // Infos membre
  const infoX = 230;
  let infoY = 185;

  ctx.fillStyle = '#FFFFFF';
  ctx.font = 'bold 36px Arial';
  ctx.textAlign = 'left';
  ctx.textBaseline = 'top';
  ctx.fillText(`${userData.prenom} ${userData.nom}`, infoX, infoY);

  infoY += 50;
  ctx.fillStyle = '#FF6B00';
  ctx.font = 'bold 24px Arial';
  ctx.fillText(`ID: BT-${Date.now().toString().slice(-6)}`, infoX, infoY);

  infoY += 40;
  ctx.fillStyle = 'rgba(255, 255, 255, 0.9)';
  ctx.font = '22px Arial';
  ctx.fillText(userData.universite || '', infoX, infoY);

  infoY += 35;
  ctx.fillText(`${userData.filiere || ''} - ${userData.niveau || ''}`, infoX, infoY);

  // Ligne footer
  ctx.strokeStyle = 'rgba(255, 255, 255, 0.2)';
  ctx.lineWidth = 2;
  ctx.beginPath();
  ctx.moveTo(40, 420);
  ctx.lineTo(816, 420);
  ctx.stroke();

  ctx.fillStyle = 'rgba(255, 255, 255, 0.8)';
  ctx.font = '20px Arial';
  ctx.textAlign = 'center';
  ctx.textBaseline = 'middle';
  ctx.fillText(`Membre depuis ${new Date().getFullYear()}`, canvas.width / 2, 470);
};

const triggerDownload = (canvas, userData) => {
  canvas.toBlob((blob) => {
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `carte-membre-${userData.nom}-${userData.prenom}.png`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  }, 'image/png');
};

// Fonction pour générer et télécharger la carte de membre
export const downloadMemberCard = (userData) => {
  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d');
  canvas.width = 856;
  canvas.height = 540;

  if (userData.photo) {
    const img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = () => {
      drawCard(ctx, canvas, userData, img);
      triggerDownload(canvas, userData);
    };
    img.onerror = () => {
      drawCard(ctx, canvas, userData, null);
      triggerDownload(canvas, userData);
    };
    img.src = userData.photo;
  } else {
    drawCard(ctx, canvas, userData, null);
    triggerDownload(canvas, userData);
  }
};

// Polyfill pour roundRect si nécessaire
if (!CanvasRenderingContext2D.prototype.roundRect) {
  CanvasRenderingContext2D.prototype.roundRect = function(x, y, width, height, radius) {
    if (width < 2 * radius) radius = width / 2;
    if (height < 2 * radius) radius = height / 2;
    this.beginPath();
    this.moveTo(x + radius, y);
    this.arcTo(x + width, y, x + width, y + height, radius);
    this.arcTo(x + width, y + height, x, y + height, radius);
    this.arcTo(x, y + height, x, y, radius);
    this.arcTo(x, y, x + width, y, radius);
    this.closePath();
    return this;
  };
}
